import React from 'react';
import * as Styled from './CouponDialogSmsSuccess.styled';
/**
 * Coupon Dialog Success displays the success messaging and new-user coupon code
 * once a user has signed up for our mailing list.
 */
const CouponDialogSmsSuccess = () => (
  <Styled.CouponDialogSmsSuccess>
    <Styled.SmsIcon />
    <Styled.Main>
      <Styled.SmsBodyHeading>
        Almost There!
        <br />
        Check your text messages.
      </Styled.SmsBodyHeading>
      <Styled.SmsBodyText>
        A text message has been sent to you.
        <br />
        Please confirm your number to start receiving early access, exclusive
        deals, and much more!
      </Styled.SmsBodyText>
    </Styled.Main>
    <Styled.Subheader>Didn&#x2019;t Get Our Text?</Styled.Subheader>
    <Styled.SmsBodyText>
      If you have an iPhone, check your Unknown Senders inbox—it could have been
      sent there.
    </Styled.SmsBodyText>
  </Styled.CouponDialogSmsSuccess>
);

export default CouponDialogSmsSuccess;
